import { render, staticRenderFns } from "./DetailsRegistration.vue?vue&type=template&id=d7452676"
import script from "./DetailsRegistration.vue?vue&type=script&lang=js"
export * from "./DetailsRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports